import store from '@/store/store';
import { POURCENTAGE, TYPE_REMISE_CASCADE } from "@/configuration/devisConf";
import { PARAMETRES_KEYS } from '@/store/modules/parametrage-mutation-type';

export function genererRemise() {
  return {
    typeRemise: POURCENTAGE,
    selected: false,
    type: TYPE_REMISE_CASCADE,
    ordre: 0,
    libelle: '',
    montant: 0,
    remise: 0,
    isRemiseRegie: false,
  };
}

export async function genererRemiseFromTauxNegocie(taux) {

  const ligneRemise = genererRemise();

  await store.dispatch('parametrage/loadParametres', [PARAMETRES_KEYS.remise]);
  const remises = store.getters['parametrage/parametre'](PARAMETRES_KEYS.remise);

  const remise = remises.find(r => r.id === taux.typeRemiseId);
  if (remise) {
    ligneRemise.libelle = remise.libelle;
    ligneRemise.isRemiseRegie = remise.isRemiseRegie;
  }
  ligneRemise.type = taux.modeCalcul;
  ligneRemise.remise = taux.remise;
  ligneRemise.typeRemise = POURCENTAGE
  return ligneRemise;
}